export default "__VITE_ASSET__ClKym3Ot__"